import { useState } from "react";
import {
  DropdownOptions,
  Flex,
  Icon,
  ModalProvider,
  Text,
  UpgradeSubscriptionModalType,
} from "dash-ui";
import { Trans, useTranslation } from "react-i18next";
import styled, { useTheme } from "styled-components";

import UpgradeSubscriptionModal from "common/components/SubscriptionComponents/UpgradeSubscriptionModalV3/UpgradeSubscriptionModalV3";
import { CancelSubscriptionModal } from "pages/ProfilePage/components/ProfileBilling/components/SubscriptionProductsSection/components";
import { AnalyticsEvent, trackEvent } from "shared/analytics";

const BannerWrapper = styled(Flex)`
  background-color: ${({ theme }) => theme.colors.g20};
  border-radius: ${({ theme }) => theme.space * 2}px;
  box-shadow: ${({ theme }) => theme.shadows.shadow2};
  cursor: pointer;
`;

const InactiveSubscriptionBanner = () => {
  const [isOpened, setIsOpened] = useState(false);
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <ModalProvider>
      <>
        <DropdownOptions />
        <UpgradeSubscriptionModal
          open={isOpened}
          onClose={() => setIsOpened(false)}
        />
        <BannerWrapper
          mb={5}
          px={4.5}
          py={5.5}
          w="100%"
          alignItems="center"
          onClick={() => {
            trackEvent(AnalyticsEvent.PAYWALL_SHOWN, {
              gate_type: UpgradeSubscriptionModalType.GENERAL,
              source: "inactive_subscription_banner",
            });
            setIsOpened(true);
          }}
        >
          <Icon
            name="viewCarousel"
            color={theme.colors.white}
            size={20}
            mr={3}
          />
          <Text color={theme.colors.white}>
            <Trans
              as="span"
              i18nKey={"common:labels.subscriptionBanner"}
              values={{
                subscriptionType: t("common:labels.subscription"),
              }}
              components={{
                tag: (
                  <Text
                    as="span"
                    semibold
                    textDecoration="underline"
                    color={theme.colors.white}
                  />
                ),
              }}
            />
          </Text>
          <CancelSubscriptionModal />
        </BannerWrapper>
      </>
    </ModalProvider>
  );
};

export default InactiveSubscriptionBanner;
